import uuid from'uuid-random';export var generateUuid=function generateUuid(){return uuid();};